<template>
    <hox-modal wrapper-class="add-account-modal" @close="close">
        <template #header>
            {{ title }}
        </template>

        <div>
            <p>Please enter all of your details below to create your Meta account.</p>
        </div>

        <div class="delete-campaign-modal__alert-wrapper">
            <Alert show-icon>
                <template #icon>
                    <icon type="md-information-circle" size="20" color="#8B919A" />
                </template>
                <p>
                    <strong>Facebook Account ID,&nbsp;</strong>
                    <strong>Page ID</strong>
                    and
                    <strong>Instagram Account ID</strong>
                    need be added as a partner to Hogarth's Business
                    <br />
                    Account:
                    <span class="link-type">
                        <strong>3704782469638109</strong>
                    </span>
                </p>
            </Alert>
            <Alert show-icon>
                <template #icon>
                    <icon type="md-information-circle" size="20" color="#8B919A" />
                </template>
                <p>
                    <strong>Origin Ad Set ID</strong>
                    is configured in your Facebook ad account and can be used to set audience targeting.
                </p>
            </Alert>
        </div>

        <div class="add-account-modal__wrap">
            <MetaAccountForm
                :initial-form-data="initialFormData"
                :action-label="title"
                @submitFormData="onSubmitForm"
            />
        </div>
    </hox-modal>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import { mapStores } from "pinia";

import MetaAccountForm, {
    type MetaAccountFormData
} from "@/Connect/components/Accounts/PlatformAccountEditMetaForm.vue";

import type { PlatformAccount } from "@/Connect/types";
import { useConnectStore } from "@/Connect/store";

export default defineComponent({
    components: {
        MetaAccountForm
    },
    props: {
        platformAccount: {
            type: Object as PropType<PlatformAccount>
        }
    },

    emits: ["close"],

    computed: {
        ...mapStores(useConnectStore),

        title() {
            if (this.platformAccount) {
                return "Edit Meta Account";
            }

            return "Add Meta Account";
        },

        initialFormData() {
            return {
                id: this.platformAccount?.id,
                accountName: this.platformAccount?.name || "",
                accountId: this.platformAccount?.platformDetails?.accountId || "",
                instagramUserId: this.platformAccount?.platformDetails?.instagramUserId || "",
                pageId: this.platformAccount?.platformDetails?.pageId || ""
            };
        }
    },

    methods: {
        close() {
            this.$emit("close");
        },

        onSubmitForm(formData: MetaAccountFormData) {
            this.$emit("close");

            if (this.platformAccount) {
                this.connectStore.updatePlatformAccount(this.platformAccount.name, {
                    name: formData.accountName,
                    platformDetails: {
                        accountId: formData.accountId,
                        instagramUserId: formData.instagramUserId,
                        pageId: formData.pageId
                    }
                });

                this.$snackbar.info("Platform account updated");

                return;
            }

            this.connectStore.addPlatformAccount({
                name: formData.accountName,
                platformDetails: {
                    type: "FACEBOOK",
                    accountId: formData.accountId,
                    instagramUserId: formData.instagramUserId,
                    pageId: formData.pageId
                }
            });

            this.$snackbar.info("Platform account added");
        }
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;

.add-account-modal {
    &--extended {
        .hox-modal {
            width: 900px;
        }
        &__form {
            width: auto;
            padding-right: 10px;
        }
    }
    &__form {
        width: 100%;
        padding-right: 0;
        .ivu-form-item {
            margin-bottom: 10px;
            &.ivu-form-item-error {
                margin-bottom: 20px;
            }
        }
        .ivu-form-item-label {
            font-weight: bold;
        }
        .ivu-btn-primary {
            margin-top: 30px;
        }
        .ivu-icon {
            font-size: 12px;
        }
    }
    &__wrap {
        display: flex;
        flex-direction: column-reverse;
        margin-top: 10px;
    }

    &__info {
        display: flex;
        align-items: center;
    }
    .hox-modal {
        width: 554px;
        &__header {
            margin-bottom: 0;
        }
        &__header-container {
            padding: 30px 30px 0;
        }
        &__body {
            padding: 2px 30px 30px;
        }
        p {
            color: #121619;
        }
    }
    .ivu-alert {
        border: none;
        background-color: #e7eaee;
        padding: 5px 8px 5px 32px;
        line-height: 22px;
        &-icon {
            left: 8px;
            top: 50%;
            transform: translateY(-50%);
        }
    }
}
</style>
